
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.407 2.712l.564 3.69c.227 1.616-.894 3.085-2.414 3.098H2.42C.926 9.5-.21 8.018.032 6.403l.564-3.69A2.497 2.497 0 012.982.5h3.039a2.497 2.497 0 012.386 2.212zm-5.648.42A1.739 1.739 0 004.5 4.859a1.739 1.739 0 001.743-1.725.334.334 0 00-.335-.332.334.334 0 00-.335.332c0 .586-.48 1.062-1.073 1.062A1.067 1.067 0 013.43 3.133a.334.334 0 00-.335-.332.334.334 0 00-.335.332z","fill":"#fff"}})])
          )
        }
      }
    